import { Instagram, Facebook, Phone, Mail } from "lucide-react";
import { BRAND } from "@/lib/constants";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#09090B] border-t border-zinc-800 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img
              src={BRAND.logo}
              alt="JE Training — Strength, Togetherness"
              className="h-24 lg:h-28 w-auto object-contain -ml-2"
            />
            <p className="mt-6 text-zinc-500 text-sm leading-relaxed font-light max-w-sm">
              Premium personal training from a private studio in Braintree,
              Essex. For every body, every goal, every stage.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="font-display text-[#D4AF37] text-xs font-bold tracking-[0.3em] uppercase mb-5">
              Contact
            </p>
            <ul className="space-y-3 text-zinc-300 text-sm">
              <li>
                <a
                  href={BRAND.phoneHref}
                  data-testid="footer-phone-link"
                  className="inline-flex items-center gap-2 hover:text-[#D4AF37] transition-colors"
                >
                  <Phone size={14} strokeWidth={1.5} /> {BRAND.phone}
                </a>
              </li>
              <li>
                <a
                  href={BRAND.emailHref}
                  data-testid="footer-email-link"
                  className="inline-flex items-center gap-2 hover:text-[#D4AF37] transition-colors break-all"
                >
                  <Mail size={14} strokeWidth={1.5} /> {BRAND.email}
                </a>
              </li>
              <li className="text-zinc-600">{BRAND.location}</li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="font-display text-[#D4AF37] text-xs font-bold tracking-[0.3em] uppercase mb-5">
              Follow
            </p>
            <div className="flex items-center gap-3">
              <a
                href={BRAND.instagram}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram-link"
                className="inline-flex items-center gap-2 px-4 py-3 border border-zinc-800 hover:border-[#D4AF37] hover:text-[#D4AF37] text-white font-display text-xs uppercase tracking-[0.2em] font-bold transition-colors duration-300"
              >
                <Instagram size={14} strokeWidth={1.5} /> Instagram
              </a>
              <a
                href={BRAND.facebook}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-facebook-link"
                className="inline-flex items-center gap-2 px-4 py-3 border border-zinc-800 hover:border-[#D4AF37] hover:text-[#D4AF37] text-white font-display text-xs uppercase tracking-[0.2em] font-bold transition-colors duration-300"
              >
                <Facebook size={14} strokeWidth={1.5} /> Facebook
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-zinc-800 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-zinc-600 text-xs">
            © {new Date().getFullYear()} JE Training. All rights reserved.
          </p>
          <p className="font-display text-zinc-700 text-xs uppercase tracking-[0.3em] font-bold">
            Strength · Togetherness
          </p>
        </div>
      </div>

      {/* Huge decorative wordmark */}
      <div className="pointer-events-none select-none relative">
        <p className="font-display text-[20vw] leading-[0.8] font-black uppercase tracking-tight text-white/[0.03] text-center pb-2">
          JE Training
        </p>
      </div>
    </footer>
  );
};

export default Footer;
